import { useSelector } from 'react-redux';
import {
  AzureMap,
  AzureMapDataSourceProvider,
  AzureMapFeature,
  AzureMapLayerProvider,
  AzureMapsProvider,
  AzureMapHtmlMarker,
  AzureMapPopup,
} from 'react-azure-maps';
import {
  Autocomplete,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';

import { Grid } from '@mui/material';

import { AuthenticationType, data } from 'azure-maps-control';
import * as atlas from 'azure-maps-control';

import { key } from './key';
// import { carData } from "./data";
// import NewMarker2 from "../../Assests/NewMarker2.svg";
// import NewMarker1 from "../../Assests/NewMarker1.svg";

import marker3 from '../../../Assests/marker3.svg';
import marker1 from '../../../Assests/marker1.svg';
import products from '../../../Assests/marker2.svg';
import capacity from '../../../Assests/processing-plant-capacity.svg';
import inBoundLine from '../../../Assests/inbound-line.svg';
import locator from '../../../Assests/locator.svg';

//
import processingPlant from '../../../Assests/processing-plant.svg';
import processingPlantAdd from '../../../Assests/processing-plant-add.svg';
import processingPlantCapacity from '../../../Assests/processing-plant-capacity.svg';
import processingPlantRemove from '../../../Assests/processing-plant-remove.svg';
import packagingPlant1 from '../../../Assests/packaging-plant-blue.svg';
import packagingPlant2 from '../../../Assests/packaging-plant-green.svg';
import packagingPlantCapacity from '../../../Assests/packaging-plant-capacity.svg';
import packagingPlantRemove from '../../../Assests/packaging-plant-remove.svg';
import supplierMap from '../../../Assests/supplier.svg';
import inBoundtoSupplier from '../../../Assests/inbound-to-supplier.svg';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';

import './style.css';
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  API_BASE_URL,
  MEDIUM_GET_AZURE_MAP_DATA,
  MEDIUM_NUTRITION_GET_AZURE_MAP_DATA,
} from '../../../Utils/Config';
import { getRequest } from '../../../Services/AxiosConfiguration';
import { MultiSelect } from 'react-multi-select-component';
// import { display } from "html2canvas/dist/types/css/property-descriptors/display";

const options = [
  { label: 'UAD', value: 'UAD' },
  { label: 'UBG', value: 'UAD' },
  { label: 'UHA', value: 'UAD' },
  { label: 'UAD', value: 'any' },
  { label: 'UAQ', value: 'any' },
  { label: 'UBG', value: 'any' },
  { label: 'UHA', value: 'any' },
  { label: 'UAD', value: 'any' },
  { label: 'UAQ', value: 'any' },
  { label: 'UBG', value: 'any' },
  { label: 'UHA', value: 'any' },
  { label: 'UAD', value: 'any' },
  { label: 'UAQ', value: 'any' },
  { label: 'UBG', value: 'any' },
  { label: 'UHA', value: 'any' },
  { label: 'UAD', value: 'any' },
  { label: 'UAQ', value: 'any' },
  { label: 'UBG', value: 'any' },
  { label: 'UHA', value: 'any' },
  { label: 'UAD', value: 'any' },
  { label: 'UAQ', value: 'any' },
  { label: 'UBG', value: 'any' },
  { label: 'UHA', value: 'any' },
];

export const MultiSelectComponent = () => {
  const [selected, setSelected] = useState([]);
  const multiSelectOptions = [
    options[options.findIndex((item) => item.value === 'any')],
    // { label: 'All', value: 'all' },
    ...options.filter((item) => item.value !== 'any'),
  ];

  const updateData = (selectedItems) => {
    if (selectedItems.find((item) => item.value === 'all')) {
      if (selectedItems.length === multiSelectOptions.length - 2) {
        return selectedItems.filter((item) => item.value !== 'all');
      } else return multiSelectOptions.filter((item) => item.value !== 'any');
    }
    if (
      selectedItems.length ===
      selected.filter((item) => item.value !== 'all').length
    ) {
      return [];
    }
    if (selectedItems.length === multiSelectOptions.length - 2) {
      return multiSelectOptions.filter((item) => item.value !== 'any');
    }
    return selectedItems;
  };

  const updateAny = (selectedItems) => {
    let anyIndex = selectedItems.findIndex((item) => item.value == 'any');
    let allIndex = selectedItems.findIndex((item) => item.value == 'all');
    if (selectedItems.find((item) => item.value === 'any')) {
      if (anyIndex < allIndex) {
        return updateData(selectedItems.filter((item) => item.value == 'all'));
      }
      if (anyIndex === 0 && allIndex == -1 && selectedItems.length > 1) {
        return selectedItems.filter((item) => item.value !== 'any');
      }
      return multiSelectOptions.filter((item) => item.value === 'any');
    }
    if (allIndex > 1) {
      return updateData(
        multiSelectOptions.filter((item) => item.value === 'all')
      );
    }
    return updateData(selectedItems);
  };

  const onHandleChange = (selectedItems) => {
    setSelected(updateAny(selectedItems));
  };

  const customValueRenderer = (selected) => {
    return selected
      .filter((item) => item.value !== 'all')
      .map((item) => item.label);
  };

  return (
    <div>
      {/* <pre>{JSON.stringify(selected)}</pre> */}
      <MultiSelect
        options={multiSelectOptions}
        value={selected}
        onChange={onHandleChange}
        valueRenderer={customValueRenderer}
        hasSelectAll={false}
      />
    </div>
  );
};

// import Checkbox from "@mui/material/Checkbox";
// import InputLabel from "@mui/material/InputLabel";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import { makeStyles } from "@mui/material/styles";

// const useStyles = makeStyles((theme) => ({
//   formControl: {
//     margin: theme.spacing(1),
//     width: 300
//   },
//   indeterminateColor: {
//     color: "#f50057"
//   },
//   selectAllText: {
//     fontWeight: 500
//   },
//   selectedAll: {
//     backgroundColor: "rgba(0, 0, 0, 0.08)",
//     "&:hover": {
//       backgroundColor: "rgba(0, 0, 0, 0.08)"
//     }
//   }
// }));

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250
//     }
//   },
//   getContentAnchorEl: null,
//   anchorOrigin: {
//     vertical: "bottom",
//     horizontal: "center"
//   },
//   transformOrigin: {
//     vertical: "top",
//     horizontal: "center"
//   },
//   variant: "menu"
// };

// const options = [
//   "Oliver Hansen",
//   "Van Henry",
//   "April Tucker",
//   "Ralph Hubbard",
//   "Omar Alexander",
//   "Carlos Abbott",
//   "Miriam Wagner",
//   "Bradley Wilkerson",
//   "Virginia Andrews",
//   "Kelly Snyder"
// ];

// export function App() {
//   const classes = useStyles();
//   const [selected, setSelected] = useState([]);
//   const isAllSelected =
//     options.length > 0 && selected.length === options.length;

//   const handleChange = (event) => {
//     const value = event.target.value;
//     if (value[value.length - 1] === "all") {
//       setSelected(selected.length === options.length ? [] : options);
//       return;
//     }
//     setSelected(value);
//   };

//   return (
//     <FormControl className={classes.formControl}>
//       <InputLabel id="mutiple-select-label">Multiple Select</InputLabel>
//       <Select
//         labelId="mutiple-select-label"
//         multiple
//         value={selected}
//         onChange={handleChange}
//         renderValue={(selected) => selected.join(", ")}
//         MenuProps={MenuProps}
//       >
//         <MenuItem
//           value="all"
//           classes={{
//             root: isAllSelected ? classes.selectedAll : ""
//           }}
//         >
//           <ListItemIcon>
//             <Checkbox
//               classes={{ indeterminate: classes.indeterminateColor }}
//               checked={isAllSelected}
//               indeterminate={
//                 selected.length > 0 && selected.length < options.length
//               }
//             />
//           </ListItemIcon>
//           <ListItemText
//             classes={{ primary: classes.selectAllText }}
//             primary="Select All"
//           />
//         </MenuItem>
//         {options.map((option) => (
//           <MenuItem key={option} value={option}>
//             <ListItemIcon>
//               <Checkbox checked={selected.indexOf(option) > -1} />
//             </ListItemIcon>
//             <ListItemText primary={option} />
//           </MenuItem>
//         ))}
//       </Select>
//     </FormControl>
//   );
// }

export default function Home3() {
  const [resultData, setResultData] = useState({});
  const [nutritionResultData, setNUTRITIONResultData] = useState({});
  // suren
  //legends show hide
  const [showLegendDetails, setshowLegendDetails] = useState(false);

  //map filters show hid
  const [showMapFiltersDetails, setshowMapFiltersDetails] = useState(false);

  const { selectedScenarioData } = useSelector(
    (state) => state.InputDataReducers
  );
  console.log(
    selectedScenarioData?.scenario === 'BaseLine',
    'selectedScenarioData'
  );

  const selectedUsecaseId = useSelector(
    (state) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state) => state.InputDataReducers.selectedCategoryId
  );

  const selectedFolderId = useSelector(
    (state) => state.InputDataReducers.selectedFolderId
  );

  const selectedScnarioId = useSelector(
    (state) => state.InputDataReducers.selectedScenarioId
  );

  const selectedTimeId = useSelector(
    (state) => state.InputDataReducers.selectedTimeId
  );

  const [show1, setShow1] = useState(true);
  const [showDepots, setShowDepots] = useState(true);
  const [show3, setShow3] = useState(true);
  const [show4, setShow4] = useState(true);
  const [show5, setShow5] = useState(true);

  // 1st senario
  const [proPlant, setProPlant] = useState(true);
  const [proPlantCapacityAdd, setProPlantCapacityAdd] = useState(true);
  const [proPlantShow, setProPlantShow] = useState(false);
  const [proPlantCapacityAddShow, setProPlantCapacityAddShow] = useState(false);
  const [depotShow, setDepotShow] = useState(false);

  //2nd senario
  const [packPlant, setPackPlant] = useState(true);
  const [packPlantAdd, setPackPlantAdd] = useState(true);
  const [proPlantShowL, setProPlantShowL] = useState(false);
  const [proPlantCapacityAddShowL, setProPlantCapacityAddShowL] = useState(false);
  const [depotShowL, setDepotShowL] = useState(false);
  const [packPlantShow, setPackPlantShow] = useState(false);
  const [packPlantAddShow, setPackPlantAddShow] = useState(false);

  const [factoryList, setFactoryList] = useState([]);
  const [formatList, setFormatList] = useState([]);
  const [basepackList, setBasepackList] = useState([]);
  const [depotList, setDepotList] = useState([]);
  const [cpTypeList, setCpTypeList] = useState([]);
  const [selectedFactory, setSelectedFactory] = useState([]);
  const [selectedFormat, setSelectedFormat] = useState([]);
  const [selectedDepot, setSelectedDepot] = useState([]);
  const [selectedBasepack, setSelectedBasepack] = useState([]);
  const [selectedCpType, setSelectedCpType] = useState([]);
  const [filterTableData, setFilterTableData] = useState([]);
  const [viewDetail, setViewDetail] = useState(false);
  const [currentDetail, setCurrentDetail] = useState({});

  //Nutrition
  const [nProcessingList, setNProcessingList] = useState([]);
  const [nFormatList, setNFormatList] = useState([]);
  const [nBasepackList, setNBasepackList] = useState([]);
  const [nDepotList, setNDepotList] = useState([]);
  const [nPackagingList, setNPackagingList] = useState([]);
  const [nSFGList, setNSFGList] = useState([]);
  const [nCpTypeList, setNCpTypeList] = useState([]);
  const [selectedNFormat, setSelectedNFormat] = useState([]);
  const [selectedNDepot, setSelectedNDepot] = useState([]);
  const [selectedNBasepack, setSelectedNBasepack] = useState([]);
  const [selectedNSFG, setSelectedNSFG] = useState([]);
  const [selectedNPackaging, setSelectedNPackaging] = useState([]);
  const [selectedNProcessing, setSelectedNProcessing] = useState([]);
  const [selectedNCpType, setSelectedNCpType] = useState([]);

  useEffect(() => {
    if (selectedUsecaseId === 2 && selectedCategoryId === 1) {
      getAzureMapData(
        selectedUsecaseId,
        selectedCategoryId,
        selectedFolderId,
        selectedScnarioId,
        'Time_Period'
      );
      setshowMapFiltersDetails(false);
      setViewDetail(false);
    } else {
      nutritionGetAzureMapData(
        selectedUsecaseId,
        selectedCategoryId,
        selectedFolderId,
        selectedScnarioId,
        'Time_Period'
      );
      setshowMapFiltersDetails(false);
      setViewDetail(false);
    }

    //callFolderFilterApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScnarioId,
    selectedTimeId,
  ]);

  useEffect(() => {
    resetFilter();
  }, [resultData]);

  useEffect(() => {
    resetNFilter();
  }, [nutritionResultData]);
  // resultData?.azureMapsMTHCFilterModel?.forEach((each) => {
    useEffect(() => {
      setshowLegendDetails(false);
    },[selectedFolderId,selectedScnarioId]);

  const checkDepotToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].depot === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const checkPackagingToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].packing === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const checkProcessingToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].processing === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const checkFactoryToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].factory_Code === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const factoryChanged = () => {
    let res = [];
    let fmList = [],
      bpList = [],
      dpList = [],
      cpTypeList = [];
    resultData?.azureMapsMTHCFilterModel?.forEach((each) => {
      if (selectedFactory.length === 0) {
        res.push(each);
      } else {
        if (selectedFactory?.some((item) => item.key === each.factory_Code)) {
          res.push(each);
        }
      }
    });

    res.forEach((each) => {
      if (each.depot) {
        if (!dpList.some((item) => item.key === each.depot)) {
          dpList.push({ key: each.depot, value: each.depot });
        }
      }

      if (each.format) {
        if (!fmList.some((item) => item.key === each.format)) {
          fmList.push({ key: each.format, value: each.format });
        }
      }

      if (each.basepack_Code) {
        if (!bpList.some((item) => item.key === each.basepack_Code)) {
          bpList.push({ key: each.basepack_Code, value: each.basepack_Code });
        }
      }

      if (each.capacityType) {
        if (!cpTypeList.some((item) => item.key === each.capacityType)) {
          cpTypeList.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    setSelectedDepot([]);
    setSelectedFormat([]);
    setSelectedBasepack([]);
    setSelectedCpType([]);

    setDepotList([...dpList]);

    setFormatList([...fmList]);

    setBasepackList([...bpList]);

    setCpTypeList([...cpTypeList]);

    console.log('inside changed factory', res);

    setFilterTableData([...res]);
  };

  const depotChanged = () => {
    let searchList = [];
    resultData?.azureMapsMTHCFilterModel?.forEach((each) => {
      if (selectedFactory.length === 0) {
        searchList.push(each);
      } else {
        if (selectedFactory?.some((item) => item.key === each.factory_Code)) {
          searchList.push(each);
        }
      }
    });

    console.log('searchList 1 ', searchList);

    let res = [];
    let fmList = [],
      bpList = [],
      cpTypeList = [];
    searchList?.forEach((each) => {
      if (selectedDepot.length === 0) {
        res.push(each);
      } else {
        if (selectedDepot?.some((item) => item.key === each.depot)) {
          res.push(each);
        }
      }
    });

    console.log('searchList 2 res', res);

    res.forEach((each) => {
      if (each.format) {
        if (!fmList.some((item) => item.key === each.format)) {
          fmList.push({ key: each.format, value: each.format });
        }
      }

      if (each.basepack_Code) {
        if (!bpList.some((item) => item.key === each.basepack_Code)) {
          bpList.push({ key: each.basepack_Code, value: each.basepack_Code });
        }
      }

      if (each.capacityType) {
        if (!cpTypeList.some((item) => item.key === each.capacityType)) {
          cpTypeList.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    setSelectedFormat([]);
    setSelectedBasepack([]);
    setSelectedCpType([]);

    setFormatList([...fmList]);
    setBasepackList([...bpList]);
    setCpTypeList([...cpTypeList]);

    setFilterTableData([...res]);
  };

  const formatChanged = () => {
    let searchList = [];
    resultData?.azureMapsMTHCFilterModel?.forEach((each) => {
      if (selectedFactory.length === 0) {
        searchList.push(each);
      } else {
        if (selectedFactory?.some((item) => item.key === each.factory_Code)) {
          searchList.push(each);
        }
      }
    });
    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedDepot.length === 0) {
        searchList.push(each);
      } else {
        if (selectedDepot?.some((item) => item.key === each.depot)) {
          searchList.push(each);
        }
      }
    });
    let res = [];

    let bpList = [],
      cpTypeList = [];
    console.log('searchList', searchList, !selectedFormat, selectedFormat);
    searchList?.forEach((each) => {
      if (selectedFormat.length === 0) {
        res.push(each);
      } else {
        if (selectedFormat?.some((item) => item.key === each.format)) {
          res.push(each);
        }
      }
    });

    res.forEach((each) => {
      if (each.basepack_Code) {
        if (!bpList.some((item) => item.key === each.basepack_Code)) {
          bpList.push({ key: each.basepack_Code, value: each.basepack_Code });
        }
      }

      if (each.capacityType) {
        if (!cpTypeList.some((item) => item.key === each.capacityType)) {
          cpTypeList.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    setSelectedBasepack([]);
    setSelectedCpType([]);

    setBasepackList([...bpList]);
    setCpTypeList([...cpTypeList]);

    setFilterTableData([...res]);
  };

  const basepackChanged = () => {
    let searchList = [];
    resultData?.azureMapsMTHCFilterModel?.forEach((each) => {
      if (selectedFactory.length === 0) {
        searchList.push(each);
      } else {
        if (selectedFactory?.some((item) => item.key === each.factory_Code)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedDepot.length === 0) {
        searchList.push(each);
      } else {
        if (selectedDepot?.some((item) => item.key === each.depot)) {
          searchList.push(each);
        }
      }
    });

    let searchList3 = [...searchList];
    searchList = [];

    searchList3?.forEach((each) => {
      if (selectedFormat.length === 0) {
        searchList.push(each);
      } else {
        if (selectedFormat?.some((item) => item.key === each.format)) {
          searchList.push(each);
        }
      }
    });

    let res = [];
    let cpTypeList = [];

    searchList?.forEach((each) => {
      if (selectedBasepack.length === 0) {
        res.push(each);
      } else {
        if (selectedBasepack?.some((item) => item.key === each.basepack_Code)) {
          res.push(each);
        }
      }
    });

    res.forEach((each) => {
      if (each.capacityType) {
        if (!cpTypeList.some((item) => item.key === each.capacityType)) {
          cpTypeList.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    setSelectedCpType([]);

    setCpTypeList([...cpTypeList]);
    setFilterTableData([...res]);
  };

  const cpTypeChanged = () => {
    let searchList = [];
    resultData?.azureMapsMTHCFilterModel?.forEach((each) => {
      if (selectedFactory.length === 0) {
        searchList.push(each);
      } else {
        if (selectedFactory?.some((item) => item.key === each.factory_Code)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedDepot.length === 0) {
        searchList.push(each);
      } else {
        if (selectedDepot?.some((item) => item.key === each.depot)) {
          searchList.push(each);
        }
      }
    });

    let searchList3 = [...searchList];
    searchList = [];

    searchList3?.forEach((each) => {
      if (selectedFormat.length === 0) {
        searchList.push(each);
      } else {
        if (selectedFormat?.some((item) => item.key === each.format)) {
          searchList.push(each);
        }
      }
    });

    let searchList4 = [...searchList];
    searchList = [];

    searchList4?.forEach((each) => {
      if (selectedBasepack.length === 0) {
        searchList.push(each);
      } else {
        if (selectedBasepack?.some((item) => item.key === each.basepack_Code)) {
          searchList.push(each);
        }
      }
    });

    let res = [];

    searchList?.forEach((each) => {
      if (selectedCpType.length === 0) {
        res.push(each);
      } else {
        if (selectedCpType?.some((item) => item.key === each.capacityType)) {
          res.push(each);
        }
      }
    });

    setFilterTableData([...res]);
  };

  //Nutrition

  const processingNChanged = () => {
    let res = [];
    let nSFGL = [],
      nPackagingL = [],
      nBasepackL = [],
      nFormatL = [],
      nDepotL = [],
      nCpTypeL = [];
    nutritionResultData?.azureMapsMTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        res.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          res.push(each);
        }
      }
    });

    res.forEach((each) => {
      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }

      if (each.format) {
        if (!nFormatL.some((item) => item.key === each.format)) {
          nFormatL.push({ key: each.format, value: each.format });
        }
      }

      if (each.basepack) {
        if (!nBasepackL.some((item) => item.key === each.basepack)) {
          nBasepackL.push({ key: each.basepack, value: each.basepack });
        }
      }

      if (each.packing) {
        if (!nPackagingL.some((item) => item.key === each.packing)) {
          nPackagingL.push({ key: each.packing, value: each.packing });
        }
      }

      if (each.sfg) {
        if (!nSFGL.some((item) => item.key === each.sfg)) {
          nSFGL.push({ key: each.sfg, value: each.sfg });
        }
      }

      if (each.capacityType) {
        if (!nCpTypeL.some((item) => item.key === each.capacityType)) {
          nCpTypeL.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    // setSelectedNProcessing("Processing");
    setSelectedNSFG([]);
    setSelectedNPackaging([]);
    setSelectedNBasepack([]);
    setSelectedNFormat([]);
    setSelectedNDepot([]);
    setSelectedNCpType([]);

    // setNProcessingList([...nProcessingL]);
    setNSFGList([...nSFGL]);
    setNPackagingList([...nPackagingL]);
    setNBasepackList([...nBasepackL]);
    setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);
    setNCpTypeList([...nCpTypeL]);

    setFilterTableData([...res]);
  };

  const SFGNChanged = () => {
    let searchList = [];
    nutritionResultData?.azureMapsMTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          searchList.push(each);
        }
      }
    });

    let res = [];
    let nPackagingL = [],
      nBasepackL = [],
      nFormatL = [],
      nDepotL = [],
      nCpTypeL = [];
    searchList?.forEach((each) => {
      if (selectedNSFG.length === 0) {
        res.push(each);
      } else {
        if (selectedNSFG?.some((item) => item.key === each.sfg)) {
          res.push(each);
        }
      }
    });

    console.log('searchList 2 res', res);

    res.forEach((each) => {
      if (each.packing) {
        if (!nPackagingL.some((item) => item.key === each.packing)) {
          nPackagingL.push({ key: each.packing, value: each.packing });
        }
      }

      if (each.basepack) {
        if (!nBasepackL.some((item) => item.key === each.basepack)) {
          nBasepackL.push({ key: each.basepack, value: each.basepack });
        }
      }

      if (each.format) {
        if (!nFormatL.some((item) => item.key === each.format)) {
          nFormatL.push({ key: each.format, value: each.format });
        }
      }

      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }

      if (each.capacityType) {
        if (!nCpTypeL.some((item) => item.key === each.capacityType)) {
          nCpTypeL.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    // setSelectedNProcessing("Processing");
    // setSelectedNSFG("SFG");
    setSelectedNPackaging([]);
    setSelectedNBasepack([]);
    setSelectedNFormat([]);
    setSelectedNDepot([]);
    setSelectedNCpType([]);

    // setNProcessingList([...nProcessingL]);
    // setNSFGList([...nSFGL]);
    setNPackagingList([...nPackagingL]);
    setNBasepackList([...nBasepackL]);
    setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);
    setNCpTypeList([...nCpTypeL]);

    setFilterTableData([...res]);
  };

  const packagingNChanged = () => {
    let searchList = [];
    nutritionResultData?.azureMapsMTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedNSFG.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNSFG?.some((item) => item.key === each.sfg)) {
          searchList.push(each);
        }
      }
    });

    let res = [];
    let nBasepackL = [],
      nFormatL = [],
      nDepotL = [],
      nCpTypeL = [];
    searchList?.forEach((each) => {
      if (selectedNPackaging.length === 0) {
        res.push(each);
      } else {
        if (selectedNPackaging?.some((item) => item.key === each.packing)) {
          res.push(each);
        }
      }
    });

    console.log('searchList 2 res', res);

    res.forEach((each) => {
      if (each.basepack) {
        if (!nBasepackL.some((item) => item.key === each.basepack)) {
          nBasepackL.push({ key: each.basepack, value: each.basepack });
        }
      }

      if (each.format) {
        if (!nFormatL.some((item) => item.key === each.format)) {
          nFormatL.push({ key: each.format, value: each.format });
        }
      }

      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }

      if (each.capacityType) {
        if (!nCpTypeL.some((item) => item.key === each.capacityType)) {
          nCpTypeL.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    // setSelectedNProcessing("Processing");
    // setSelectedNSFG("SFG");
    // setSelectedNPackaging("Packaging");
    setSelectedNBasepack([]);
    setSelectedNFormat([]);
    setSelectedNDepot([]);
    setSelectedNCpType([]);

    // setNProcessingList([...nProcessingL]);
    // setNSFGList([...nSFGL]);
    // setNPackagingList([...nPackagingL]);
    setNBasepackList([...nBasepackL]);
    setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);
    setNCpTypeList([...nCpTypeL]);

    setFilterTableData([...res]);
  };

  const basepackNChanged = () => {
    let searchList = [];
    nutritionResultData?.azureMapsMTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedNSFG.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNSFG?.some((item) => item.key === each.sfg)) {
          searchList.push(each);
        }
      }
    });

    let searchList3 = [...searchList];
    searchList = [];

    searchList3?.forEach((each) => {
      if (selectedNPackaging.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNPackaging?.some((item) => item.key === each.packing)) {
          searchList.push(each);
        }
      }
    });

    let res = [];
    let nFormatL = [],
      nDepotL = [],
      nCpTypeL = [];
    searchList?.forEach((each) => {
      if (selectedNBasepack.length === 0) {
        res.push(each);
      } else {
        if (selectedNBasepack?.some((item) => item.key === each.basepack)) {
          res.push(each);
        }
      }
    });

    console.log('searchList 2 res', res);

    res.forEach((each) => {
      if (each.format) {
        if (!nFormatL.some((item) => item.key === each.format)) {
          nFormatL.push({ key: each.format, value: each.format });
        }
      }

      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }

      if (each.capacityType) {
        if (!nCpTypeL.some((item) => item.key === each.capacityType)) {
          nCpTypeL.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    // setSelectedNProcessing("Processing");
    // setSelectedNSFG("SFG");
    // setSelectedNPackaging("Packaging");
    // setSelectedNBasepack("Basepack");
    setSelectedNFormat([]);
    setSelectedNDepot([]);
    setSelectedNCpType([]);

    // setNProcessingList([...nProcessingL]);
    // setNSFGList([...nSFGL]);
    // setNPackagingList([...nPackagingL]);
    // setNBasepackList([...nBasepackL]);
    setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);
    setNCpTypeList([...nCpTypeL]);

    setFilterTableData([...res]);
  };

  const formatNChanged = () => {
    let searchList = [];
    nutritionResultData?.azureMapsMTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedNSFG.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNSFG?.some((item) => item.key === each.sfg)) {
          searchList.push(each);
        }
      }
    });

    let searchList3 = [...searchList];
    searchList = [];

    searchList3?.forEach((each) => {
      if (selectedNPackaging.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNPackaging?.some((item) => item.key === each.packing)) {
          searchList.push(each);
        }
      }
    });

    let searchList4 = [...searchList];
    searchList = [];

    searchList4?.forEach((each) => {
      if (selectedNBasepack.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNBasepack?.some((item) => item.key === each.basepack)) {
          searchList.push(each);
        }
      }
    });

    let res = [];
    let nDepotL = [],
      nCpTypeL = [];
    searchList?.forEach((each) => {
      if (selectedNFormat.length === 0) {
        res.push(each);
      } else {
        if (selectedNFormat?.some((item) => item.key === each.format)) {
          res.push(each);
        }
      }
    });

    console.log('searchList 2 res', res);

    res.forEach((each) => {
      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }

      if (each.capacityType) {
        if (!nCpTypeL.some((item) => item.key === each.capacityType)) {
          nCpTypeL.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    // setSelectedNProcessing("Processing");
    // setSelectedNSFG("SFG");
    // setSelectedNPackaging("Packaging");
    // setSelectedNBasepack("Basepack");
    // setSelectedNFormat("Format");
    setSelectedNDepot([]);
    setSelectedNCpType([]);

    // setNProcessingList([...nProcessingL]);
    // setNSFGList([...nSFGL]);
    // setNPackagingList([...nPackagingL]);
    // setNBasepackList([...nBasepackL]);
    // setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);
    setNCpTypeList([...nCpTypeL]);

    setFilterTableData([...res]);
  };

  const depotNChanged = () => {
    let searchList = [];
    nutritionResultData?.azureMapsMTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedNSFG.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNSFG?.some((item) => item.key === each.sfg)) {
          searchList.push(each);
        }
      }
    });

    let searchList3 = [...searchList];
    searchList = [];

    searchList3?.forEach((each) => {
      if (selectedNPackaging.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNPackaging?.some((item) => item.key === each.packing)) {
          searchList.push(each);
        }
      }
    });

    let searchList4 = [...searchList];
    searchList = [];

    searchList4?.forEach((each) => {
      if (selectedNBasepack.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNBasepack?.some((item) => item.key === each.basepack)) {
          searchList.push(each);
        }
      }
    });

    let searchList5 = [...searchList];
    searchList = [];

    searchList5?.forEach((each) => {
      if (selectedNFormat.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNFormat?.some((item) => item.key === each.format)) {
          searchList.push(each);
        }
      }
    });

    let nCpTypeL = [];

    let searchList6 = [...searchList];
    searchList = [];

    let res = [];

    searchList6?.forEach((each) => {
      if (selectedNDepot.length === 0) {
        res.push(each);
      } else {
        if (selectedNDepot?.some((item) => item.key === each.depot)) {
          res.push(each);
        }
      }
    });

    res.forEach((each) => {
      if (each.capacityType) {
        if (!nCpTypeL.some((item) => item.key === each.capacityType)) {
          nCpTypeL.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    console.log('searchList 2 res', res);

    setSelectedNCpType([]);

    setNCpTypeList([...nCpTypeL]);

    setFilterTableData([...res]);
  };

  const cpTypeNChanged = () => {
    let searchList = [];
    nutritionResultData?.azureMapsMTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedNSFG.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNSFG?.some((item) => item.key === each.sfg)) {
          searchList.push(each);
        }
      }
    });

    let searchList3 = [...searchList];
    searchList = [];

    searchList3?.forEach((each) => {
      if (selectedNPackaging.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNPackaging?.some((item) => item.key === each.packing)) {
          searchList.push(each);
        }
      }
    });

    let searchList4 = [...searchList];
    searchList = [];

    searchList4?.forEach((each) => {
      if (selectedNBasepack.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNBasepack?.some((item) => item.key === each.basepack)) {
          searchList.push(each);
        }
      }
    });

    let searchList5 = [...searchList];
    searchList = [];

    searchList5?.forEach((each) => {
      if (selectedNFormat.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNFormat?.some((item) => item.key === each.format)) {
          searchList.push(each);
        }
      }
    });

    let nCpTypeL = [];

    let searchList6 = [...searchList];
    searchList = [];

    searchList6?.forEach((each) => {
      if (selectedNDepot.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNDepot?.some((item) => item.key === each.depot)) {
          searchList.push(each);
        }
      }
    });

    let res = [];

    searchList?.forEach((each) => {
      if (selectedNCpType.length === 0) {
        res.push(each);
      } else {
        if (selectedNCpType?.some((item) => item.key === each.capacityType)) {
          res.push(each);
        }
      }
    });
    setFilterTableData([...res]);
  };

  useEffect(() => {
    factoryChanged();
  }, [selectedFactory]);

  useEffect(() => {
    depotChanged();
  }, [selectedDepot]);

  useEffect(() => {
    formatChanged();
  }, [selectedFormat]);

  useEffect(() => {
    basepackChanged();
  }, [selectedBasepack]);

  useEffect(() => {
    cpTypeChanged();
  }, [selectedCpType]);

  //nutrition

  useEffect(() => {
    processingNChanged();
  }, [selectedNProcessing]);

  useEffect(() => {
    SFGNChanged();
  }, [selectedNSFG]);

  useEffect(() => {
    packagingNChanged();
  }, [selectedNPackaging]);

  useEffect(() => {
    formatNChanged();
  }, [selectedNFormat]);

  useEffect(() => {
    basepackNChanged();
  }, [selectedNBasepack]);

  useEffect(() => {
    depotNChanged();
  }, [selectedNDepot]);

  useEffect(() => {
    cpTypeNChanged();
  }, [selectedNCpType]);

  //let resultData={};
  const getAzureMapData = (
    usecaseId,
    category_Id,
    folder_id,
    scenarioId,
    Time_Period
  ) => {
    const urls = API_BASE_URL + MEDIUM_GET_AZURE_MAP_DATA;
    const header = {
      accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    };
    getRequest(
      // urls,
      API_BASE_URL + '/baselinecost/mediumterm/homecare/maps',
      {
        usecaseId: usecaseId,
        category_Id: category_Id,
        folder_id: folder_id,
        scenario_id: scenarioId,
        Time_Period: Time_Period,
      },
      header
    )
      .then((response) => {
        console.log('Responsed: ', response.data);
        //dispatch(getScenarioNumberSuccess(response.data));
        //let dataResult = JSON.parse(response.data);
        //console.log("JSON Parse", dataResult)
        let result = response.data;

        let hcFilterObject = [];
        response?.data?.azureMapsMTHCFilterModel?.forEach((each) => {
          let obj = { ...each };
          obj.depot = each.demand_Location_Code;
          hcFilterObject.push(obj);
        });

        result.azureMapsMTHCFilterModel = hcFilterObject;

        setResultData(result);
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        // dispatch(getScenarioNumberError(error));
      });
  };
  const nutritionGetAzureMapData = (
    usecaseId,
    category_Id,
    folder_id,
    scenarioId,
    Time_Period
  ) => {
    const urls = API_BASE_URL + MEDIUM_NUTRITION_GET_AZURE_MAP_DATA;
    const header = {
      accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    };
    getRequest(
      // urls,
      API_BASE_URL + '/baselinecost/mediumterm/nutrition/maps',
      {
        usecaseId: usecaseId,
        category_Id: category_Id,
        folder_id: folder_id,
        scenario_id: scenarioId,
        Time_Period: Time_Period,
      },
      header
    )
      .then((response) => {
        //   console.log('Response: ', response);
        //dispatch(getScenarioNumberSuccess(response.data));
        console.log('Map out data', response.data);
        //let dataResult = JSON.parse(response.data);
        //console.log("JSON Parse", dataResult)
        let result = response.data;

        // let nutFilterObject = [];
        // response?.data?.azureMapsMTNutritionFilterModel?.forEach((each) => {
        //   let obj = { ...each };
        //   obj.factory_Code = each.processing;
        //   obj.basepack_Code = each.basepack;
        //   nutFilterObject.push(obj);
        // })

        // result.azureMapsMTHCFilterModel = nutFilterObject;

        // setResultData(result);

        setNUTRITIONResultData(result);
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        // dispatch(getScenarioNumberError(error));
      });
  };
  const nutritionPoints =
    nutritionResultData?.mediumTermNutrition_AzureMapsModel?.points?.length > 0
      ? nutritionResultData?.mediumTermNutrition_AzureMapsModel?.points
      : [];

  const points =
    resultData?.mediumTermHC_AzureMapsModel?.points?.length > 0
      ? resultData?.mediumTermHC_AzureMapsModel?.points
      : [
          // {
          //   source: [76.1456, 30.3647],
          //   destination: [77.8271, 12.7280],
          // },
          // {
          //   source: [76.1456, 30.3647],
          //   destination: [77.8271, 12.7280],
          // },
          // {
          //   source:[77.8271, 12.7280],
          //   destination: [72.5918, 23.0145],
          // },
          // {
          //   source: [76.1456, 30.3647],
          //   destination: [77.5667, 12.9667],
          // },
          // {
          //   source:[77.5667, 12.9667],
          //   destination: [72.5918, 23.0145],
          // },
          // {
          //   source:[77.8271, 12.7280],
          //   destination: [77.7200, 13.4300],
          // },
          // {
          //   source:[77.5667, 12.9667],
          //   destination: [77.7200, 13.4300],
          // },
        ];

  const nutritionCoordinates =
    nutritionResultData?.mediumTermNutrition_AzureMapsModel?.coordinates
      ?.length > 0
      ? nutritionResultData?.mediumTermNutrition_AzureMapsModel?.coordinates
      : [];
  const coordinates =
    resultData?.mediumTermHC_AzureMapsModel?.coordinates?.length > 0
      ? resultData?.mediumTermHC_AzureMapsModel?.coordinates
      : [
          // {
          //   latitude: 23.0145,
          //   longitude: 72.5918,
          //   text: "Ahmedabad",
          //   title: "Ahmedabad"
          // },
          // {
          //   latitude: 13.4300,
          //   longitude: 77.7200,
          //   text: "Chikkaballapur",
          //   title: "Chikkaballapur"
          // }
        ];

  const nutritionPackaging =
    nutritionResultData?.mediumTermNutrition_AzureMapsModel?.packagingCoords
      ?.length > 0
      ? nutritionResultData?.mediumTermNutrition_AzureMapsModel?.packagingCoords
      : [];

  // {
  //   latitude: 12.9667,
  //   longitude: 77.5667,
  //   title: "Rohini Packer",
  //   text: "Rohini Packer",
  // },

  // {
  //   latitude: 12.7280,
  //   longitude: 77.8271,
  //   text: "Hosur",
  //   title: "Hosur"

  // }

  const nutritionFactoryCoords =
    nutritionResultData?.mediumTermNutrition_AzureMapsModel?.factoryCoords
      ?.length > 0
      ? nutritionResultData?.mediumTermNutrition_AzureMapsModel?.factoryCoords
      : [];

  const factoryCoords =
    resultData?.mediumTermHC_AzureMapsModel?.factoryCoords?.length > 0
      ? resultData?.mediumTermHC_AzureMapsModel?.factoryCoords
      : [
          //  {
          //   latitude: 12.9667,
          //   longitude: 77.5667,
          //   title: "Rohini Packer",
          //   text: "Rohini Packer",
          // },
          //  {
          //   latitude: 30.3647,
          //   longitude: 76.1456,
          //   title: "Nabha",
          //   text: "Nabha",
          // }
        ];

  let popUpContent = [];
  let popupPosition = '';
  function mouseOverLineString(e) {
    popUpContent = [];
    const ele = e.target?.element;
    if (e.target && e.target?.options?.position?.length > 0) {
      console.log(e.target?.options, 'contentttt');
      if (e.target?.options?.htmlContent.toString().includes('marker1')) {
        popupPosition = 'Depo';
      } else if (
        e.target?.options?.htmlContent.toString().includes('marker2')
      ) {
        popupPosition = 'Packaging';
      } else {
        popupPosition = 'Factory';
      }
      popUpContent.push(e.target?.options?.position, e.target?.options?.text);
    }
  }

  const onClick = (e) => {
    atlas.Popup(true);
  };

  const eventToMarker = [
    { eventName: 'mousemove', callback: mouseOverLineString },
  ];

  const renderPoint = (data) => {
    let point1 = data.source;
    let point2 = data.destination;
    let out = curvePlot(point1, point2);
    return (
      <AzureMapFeature
        key={'Line String Feature'}
        id={'Line Strign ID'}
        type={'LineString'}
        coordinates={[...out]}
      />
    );
  };

  function renderDepotPoints() {
    const rendId = Math.random();
    setDepotShow(false);
    setDepotShowL(false);
    if(coordinates?.length > 0 ){
      setDepotShow(true);
    }
    if(nutritionCoordinates?.length > 0 ){
      setDepotShowL(true);
    }
    return (
      <>
        {selectedCategoryId === 1 ? (
          <>
            {coordinates.map((coordinate, idx) => {
              return (
                // (selectedDepot === "Depot") || (selectedFactory === coordinate.text || selectedDepot === coordinate.text) ? (

                checkDepotToShow(coordinate) ? (
                  <AzureMapHtmlMarker
                    key={idx}
                    markerContent={
                      <div>
                        <img
                          className={'marker-1-style'}
                          src={marker1}
                          title={'Depot: ' + coordinate.text}
                        />

                        {/* <img className={"marker-1-style"} src={products} /> */}

                        {/* <img className={"marker-1-style"} src={NewMarker1} /> */}
                        {/* <img className={"marker-1-style"} src={NewMarker2} /> */}
                      </div>
                    }
                    options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                    events={[
                      {
                        eventName: 'click',
                        callback: () =>
                          mapPointClicked(coordinate, 'Depot', marker1),
                      },
                    ]}
                  />
                ) : null
              );
            })}
          </>
        ) : (
          <>
            {nutritionCoordinates?.map((coordinate, idx) => {
              return (
                // (selectedDepot === "Depot") || (selectedFactory === coordinate.text || selectedDepot === coordinate.text) ? (
                checkDepotToShow(coordinate) ? (
                  <AzureMapHtmlMarker
                    key={idx}
                    markerContent={
                      <div>
                        <img
                          className={'marker-1-style'}
                          src={marker1}
                          title={'Depot: ' + coordinate.text}
                        />

                        {/* <img className={"marker-1-style"} src={products} /> */}

                        {/* <img className={"marker-1-style"} src={NewMarker1} /> */}
                        {/* <img className={"marker-1-style"} src={NewMarker2} /> */}
                      </div>
                    }
                    options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                    events={[
                      {
                        eventName: 'click',
                        callback: () =>
                          mapPointClicked(coordinate, 'Depot', marker1),
                      },
                    ]}
                  />
                ) : null
              );
            })}
          </>
        )}
        {/* 
{states.map((state, idx) => {
        return (
          
          <AzureMapHtmlMarker
            key={idx}
            markerContent={
              <div>
                <img className={"marker-1-style"} src={marker4} />
              </div>
            }
            options={{ ...azureHtmlMapMarkerOptions(state) }}
            events={eventToMarker}
          />
        );
      })} */}
      </>
    );
  }

  factoryCoords.map((item) => {
    if (item.capacityflag === 'one') {
      console.log(item, 'markerValue');
    }
  });

  function renderFactoryPoints() {
    const rendId = Math.random();
    setProPlantShow(false);
    setProPlantCapacityAddShow(false);
    setProPlantShowL(false);
    setProPlantCapacityAddShowL(false);
    return (
      <>
        {selectedCategoryId === 1 ? (
          <>
            {factoryCoords.map((coordinate, idx) => {
              let factFlag = coordinate.capacityflag;
              let coText = coordinate.text;
              let ppText = 'Factory: ';
              let imgClrFlag;
              switch (factFlag) {
                case 'zero': // processing plant
                setProPlantShow(true);
                  if (proPlant) {
                    imgClrFlag = processingPlant;
                  } else {
                    coText = '';
                    ppText = '';
                  }

                  break;
                case 'one': // Processing Plant Capacity Add
                setProPlantCapacityAddShow(true);
                  if (proPlantCapacityAdd) {
                    imgClrFlag = processingPlantCapacity;
                  } else {
                    coText = '';
                    ppText = '';
                  }

                  break;

                default:
                  imgClrFlag = processingPlant;
              }

              return (
                // (selectedFactory === "Factory" || selectedFactory === "") || (selectedFactory === coordinate.text || selectedDepot === coordinate.depot) ? (
                checkFactoryToShow(coordinate) ? (
                  <AzureMapHtmlMarker
                    key={idx}
                    markerContent={
                      <div>
                        <img
                          className={'marker-3-style2'}
                          src={imgClrFlag ? imgClrFlag : ''}
                          title={ppText + coText}
                        />
                      </div>
                    }
                    options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                    events={[
                      {
                        eventName: 'click',
                        callback: () => {
                          if (coordinate?.capacityFlag === 'one') {
                            mapPointClicked(
                              coordinate,
                              'Processing Plant',
                              capacity
                            );
                          } else {
                            mapPointClicked(
                              coordinate,
                              'Processing Plant',
                              marker3
                            );
                          }
                        },
                      },
                    ]}
                  />
                ) : null
              );
            })}
          </>
        ) : (
          <>
            {nutritionFactoryCoords?.map((coordinate, idx) => {
              let factFlag = coordinate.capacityflag;
              let coText = coordinate.text;
             //let imgHeight='36px';
              let ppText = 'Factory: ';
              let imgClrFlag;
              switch (factFlag) {
                case 'zero': // processing plant
                setProPlantShowL(true);
                  if (proPlant) {
                    imgClrFlag = processingPlant;
                  } else {
                    coText = '';
                    ppText = '';
                    //imgHeight = '';
                  }

                  break;
                case 'one': // Processing Plant Capacity Add
                setProPlantCapacityAddShowL(true);
                  if (proPlantCapacityAdd) {
                    imgClrFlag = processingPlantCapacity;
                  } else {
                    coText = '';
                    ppText = '';
                    //imgHeight = '';
                  }

                  break;

                default:
                  imgClrFlag = processingPlant;
              }
              return checkProcessingToShow(coordinate) ? (
                <AzureMapHtmlMarker
                  key={idx}
                  markerContent={
                    <div>
                      <img
                        className={'marker-3-style'}
                        src={imgClrFlag ? imgClrFlag : ''}
                        title={ppText + coText}
                        // height={imgHeight}
                      />
                    </div>
                  }
                  options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                  events={[
                    {
                      eventName: 'click',
                      callback: () => {
                        if (coordinate?.capacityFlag === 'one') {
                          mapPointClicked(
                            coordinate,
                            'Processing Plant',
                            capacity
                          );
                        } else {
                          mapPointClicked(
                            coordinate,
                            'Processing Plant',
                            marker3
                          );
                        }
                      },
                    },
                  ]}
                />
              ) : null;
            })}
          </>
        )}
      </>
    );
  }

  function renderPackagingPoints() {
    const rendId = Math.random();
    setPackPlantShow(false);
    setPackPlantAddShow(false);
    return (
      <>
        {nutritionPackaging?.map((packaging, idx) => {
          let factFlag = packaging?.capacityflag;
          let coText = packaging?.text;
         // let imgHeight='36px';
          let ppText = 'Factory: ';
          let imgClrFlag;

          switch (factFlag) {
            case 'zero': //  packaging plant
            setPackPlantShow(true);
              if (packPlant) {
                imgClrFlag = packagingPlant1;
              } else {
                coText = '';
                ppText = '';
               // imgHeight = '';
              }

              break;
            case 'one': // new packaging plant
            setPackPlantAddShow(true);
              if (packPlantAdd) {
                imgClrFlag = packagingPlantCapacity;
              } else {
                coText = '';
                ppText = '';
               // imgHeight = '';
              }

              break;

            default:
              imgClrFlag = packagingPlant1;
          }
          return checkPackagingToShow(packaging) ? (
            <AzureMapHtmlMarker
              key={idx}
              markerContent={
                <div>
                  <img
                    className={'marker-3-style'}
                    src={imgClrFlag ? imgClrFlag : ''}
                    title={ppText + coText}
                    // height={imgHeight}
                  />
                </div>
              }
              options={{ ...azureHtmlMapMarkerOptions(packaging) }}
              events={[
                {
                  eventName: 'click',
                  callback: () => {
                    if (packaging?.capacityFlag === 'one') {
                      mapPointClicked(
                        packaging,
                        'Packaging Plant',
                        packagingPlantCapacity
                      );
                    } else {
                      mapPointClicked(packaging, 'Packaging Plant', products);
                    }
                  },
                },
              ]}
            />
          ) : null;
        })}

        {/* 
{states.map((state, idx) => {
        return (
          
          <AzureMapHtmlMarker
            key={idx}
            markerContent={
              <div>
                <img className={"marker-1-style"} src={marker4} />
              </div>
            }
            options={{ ...azureHtmlMapMarkerOptions(state) }}
            events={eventToMarker}
          />
        );
      })} */}
      </>
    );
  }

  function azureHtmlMapMarkerOptions(coordinate) {
    return {
      //position: [coordinate.latitude, coordinate.longitude],
      position: [coordinate.longitude, coordinate.latitude],
      text: coordinate.text,
      title: coordinate.title,
    };
  }

  const curvePlot = (point1, point2, color) => {
    let startX = point1[0];
    let startY = point1[1];

    let endX = point2[0];
    let endY = point2[1];

    let centerX = (startX + endX) / 2;
    let centerY = (startY + endY) / 2;

    let slope = (endY - startY) / (endX - startX);
    let c1 = endY - slope * endX;
    let nslope = (1 / slope) * -1;
    let c = slope * centerX + centerX / slope + c1; //c for perpendicular line
    //eq of perpendicular line : y = (-1/slope)x + c

    //Now solve quadratic eq: ax2 + bx + c2 = 0
    let a = 1 + nslope * nslope;
    let b = 2 * nslope * c - 2 * centerX - 2 * nslope * centerY;
    let c2 =
      centerX * centerX + centerY * centerY + c * c - 2 * centerY * c - 2;

    let reqX = (-b - Math.sqrt(Math.abs(b * b - 4 * a * c2))) / (2 * a);
    let reqY = nslope * reqX + c;
    // const svgContainer = document.getElementById("svg-container");
    // const curveColor = "red";
    // const curveElement = curvePlot([100, 100], [300, 200], curveColor);
    // svgContainer.appendChild(curveElement);
    let out = [];
    out.push(point1);
    // out.setAttribute("fill", "none");
    // out.setAttribute("stroke", "red"); // Set the stroke color
    // out.setAttribute("d", `M ${point1[0]},${point1[1]} C ${out.join(" ")}`); // Set the path data

    let bezierX = reqX;
    let bezierY = reqY;

    // for (let t = 0.0; t <= 1; t += 0.01) {
    //   let x =
    //     (1 - t) * (1 - t) * startX + 2 * (1 - t) * t * bezierX + t * t * endX;
    //   let y =
    //     (1 - t) * (1 - t) * startY + 2 * (1 - t) * t * bezierY + t * t * endY;
    //   out.push([x, y]);
    // }
    out.push(point2);
    return out;
  };

  const renderMarker = () => {
    const rendId = Math.random();

    return (
      <AzureMapFeature
        key={rendId}
        id={rendId.toString()}
        type="Point"
        coordinate={coordinates}
        nutritionPackaging={nutritionPackaging}
        // state = {states}
        properties={{
          title: 'Pin',
          icon: 'pin-round-blue',
        }}
      />
    );
  };

  const calculateDistance = (point1, point2) => {
    let dis =
      Math.pow(point1[0] - point2[0], 2) + Math.pow(point1[1] - point2[1], 2);
    return Math.sqrt(dis);
  };

  <AzureMapFeature
    key={data.licensePlate}
    id={data.licensePlate}
    type="Point"
    coordinate={data}
    packaging={data}
    state={data}
    properties={{
      id: data.licensePlate,
      popUpProp: data,
    }}
  />;

  const MarkersExample = () => {
    // const [mapData, setMapData] = useState([...carData]);
    // const [mapData, setMapData] = useState([...points]);
    const [popupProperties, setPopupProperties] = useState('');
    const [popupOptions, setPopupOptions] = useState({});
    const option = useMemo(() => {
      return {
        authOptions: {
          authType: AuthenticationType.subscriptionKey,
          subscriptionKey: key,
        },
        //center: mapData.position,
        //center: [carData.position.latitude, carData.position.longitude],
        center: [77.580643, 20.972442],
        zoom: 3.4,
        view: 'Auto',
        visibility: 'off',
        // scrollZoomInteraction: coordinates && coordinates.length > 0 ? true : false
      };
    }, []);

    var popup = new atlas.Popup({});
    const mapRef = useRef(null);

    const handleZoom = (e) => {
      const zoomLevel = e?.map?.map?.getZoom();
      if (zoomLevel > 0) {
        let layers = e?.map?.map?.getStyle().layers;

        for (let i = 0; i < layers.length; i++) {
          if (
            layers[i].type == 'symbol' &&
            layers[i].source == 'vectorTiles' &&
            layers[i].layout &&
            layers[i].layout['text-field'] &&
            layers[i].layout['text-field'] !== ''
          ) {
            e?.map?.map?.setLayoutProperty(layers[i].id, 'visibility', 'none');
          }
        }
      } else {
        let layers = e?.map?.map?.getStyle().layers;
        for (let i = 0; i < layers.length; i++) {
          if (
            layers[i].type == 'symbol' &&
            layers[i].source == 'vectorTiles' &&
            layers[i].layout &&
            layers[i].layout['text-field'] &&
            layers[i].layout['text-field'] !== ''
          ) {
            e?.map?.map.setLayoutProperty(layers[i].id, 'visibility', 'none');
          }
        }
      }
    };
    useEffect(() => {
      // console.log(popupOptions, "popupOptions")
    }, [popupOptions]);

    const memoizedMarkerRender = useMemo(
      () =>
        points
          ?.filter((each) => {
            // if (each.factory_Code === selectedFactory) {
            //   return each;
            // } else if (selectedFactory === "Factory") {
            //   return each;
            // }
            // console.log('each point', each, filterTableData);
            if (selectedFactory.length === 0 && selectedDepot.length === 0 && selectedFormat.length === 0 && selectedBasepack.length === 0 && selectedCpType.length === 0) {
              return each;
            } else {
              let flag1 = false,
              flag2 = false,
              flag3 = false,
              flag4 = false,
                flag5 = false;
              filterTableData.forEach((e) => {
                if (e.factory_Code === each.factorycode) {
                  flag1 = true;
                }
                if (e.depot === each.depotcode) {
                  flag2 = true;
                }
                if (e.format === each.format) {
                  flag3 = true;
                }
                if (e.basepack_Code === each.basepackcode) {
                  flag4 = true;
                }
                if (e.capacityType === each.capacity_type) {
                  flag5 = true;
                }
              });
              if (flag1 && flag2 ) {
                return each;
              }
            }
          })
          .map((el) => renderPoint(el)),
      []
    );

    const nutritionMemoizedMarkerRender = useMemo(
      () =>
        nutritionPoints
          ?.filter((each) => {
            console.log('each point nutrition', each, filterTableData);
            if (
              selectedNProcessing.length === 0 &&
              selectedNDepot.length === 0 &&
              selectedNPackaging.length === 0 &&
              selectedNSFG.length === 0 &&
              selectedNBasepack.length === 0 &&
              selectedNFormat.length === 0 &&
              selectedNCpType.length === 0
            ) {
              return each;
            } else {
              let flag1 = false,
                flag2 = false,
                flag3 = false,
                flag4 = false;
              filterTableData.forEach((e) => {
                if (e.processing === each.factorycode) {
                  flag1 = true;
                }
                if (e.depot === each.depotcode) {
                  flag2 = true;
                }
                if (e.packing === each.factorycode) {
                  flag3 = true;
                }
                if (e.packing === each.depotcode) {
                  flag4 = true;
                }
                
              });
              if (flag1 && flag2) {
                return each;
              }
              if (flag2 && flag3) {
                return each;
              }
              if (flag1 && flag4) {
                return each;
              }
            }
          })
          .map((el) => renderPoint(el)),
      []
    );

    // const map1Render = useMemo(
    //   () => map1.map((el) => renderPoint(el)),
    //   [map1]
    // );

    // const map2Render = useMemo(
    //   () => map2.map((el) => renderPoint(el)),
    //   [map2]
    // );

    const wrapperStyles = {
      map: {
        height: '700px',
        width: '100%',
      },
      wrapper: {
        padding: '15px',
        marginTop: '15px',
      },
      buttonContainer: {
        display: 'grid',
        gridAutoFlow: 'column',
        gridGap: '10px',
        gridAutoColumns: 'max-content',
        padding: '10px 0',
      },
      buttons: {
        padding: '15px',
        flex: 1,
      },
      popupStyles: {
        padding: '20px',
        color: 'black',
      },
    };

    return (
      <>
        <AzureMapsProvider>
          <div style={wrapperStyles.map}>
            <AzureMap options={option}>
              <AzureMapDataSourceProvider
                events={{
                  dataadded: (e) => {
                    //    console.log("Data on source added", e);
                  },
                }}
                id={'routeExample AzureMapDataSourceProvider'}
                options={{
                  // This sample shows how to apply a stroke gradient to a line on the map.\
                  // In order to apply this feature to a line, the data source must have the lineMetrics option set to true.
                  lineMetrics: true,
                }}
              >
                <AzureMapLayerProvider
                  id={'routeExample AzureMapLayerProvider'}
                  options={{
                    // lineJoin: "round",
                    //  pathType: 'original',
                    // lineCap: "round",
                    // width: 3,
                    // lineDash: [40,10], // <- [dashLength, dashSpace]
                    strokeGradient: [
                      'interpolate',
                      ['linear'],
                      ['line-progress'],
                      0,
                      '#73706E',
                    ],
                    strokeColor: ['get', 'strokeColor'],
                    strokeWidth: ['get', 'strokeWidth'],
                    lineJoin: 'round',
                    lineCap: 'round',
                  }}
                  events={{
                    mouseOverLineString: (e) => {
                      //     console.log("liner");
                    },
                    wheel: (e) => {
                      handleZoom(e);
                    },
                    mouseleave: () => {
                      setPopupOptions(() => {});
                    },
                    // mouseenter: mouseOverLineString,
                    mousemove: (e) => {
                      return;
                      //   console.log("shapes", e?.shapes);
                      // var popupTemplate = '<div class="customInfobox"><div class="name">{name}</div>{description}</div>';
                      // var content, coordinate;
                      // var properties = e.shapes[0].getProperties();
                      if (e.shapes && e.shapes.length > 0) {
                        // var content, coordinate;
                        // var properties = e.shapes[0].getProperties();
                        // content = popupTemplate.replace(/{name}/g, properties.name).replace(/{description}/g, properties.description);
                        // coordinate = e.shapes[0].getCoordinates();
                        // console.log("shapes", e?.shapes);
                        const prop = e.target?.options;
                        // Set popup options
                        setPopupOptions({
                          ...popupOptions,
                          position: new data.Position(
                            e?.position[0],
                            e?.position[1]
                          ),
                          pixelOffset: [0, -8],
                        });
                        setPopupProperties('Position: ' + popupPosition);
                        // var popup = new atlas.Popup({
                        //   pixelOffset: [0, -18],
                        //   closeButton: false
                        // });
                        // popup.setOptions({
                        //   content: "Hello",
                        //   //Update the popup's position with the symbol's coordinate.
                        //   position: e.shapes[0].getCoordinates(),
                        //   pixelOffset: [0, -18]
                        // })
                        // popup.open();
                        if (prop?.text)
                          // Set popup properties from Feature Properties that are declared on create Feature
                          setPopupProperties([...popupProperties, prop?.text]);
                      }
                    },
                  }}
                  lifecycleEvents={{
                    layeradded: (e) => {
                      //     console.log("LAYER ADDED TO MAP", e);
                    },
                    type: 'Feature',
                    properties: {},
                    geometry: {
                      type: 'LineString',
                      coordinates: [
                        [144.9586, -37.848381],
                        [-118.1948, 33.767109],
                      ],
                    },
                  }}
                  type={'LineLayer'}
                />
                {selectedCategoryId === 1
                  ? showDepots && proPlant && proPlantCapacityAdd
                    ? memoizedMarkerRender // for lines
                    : null
                  : packPlant &&
                    packPlantAdd &&
                    showDepots &&
                    proPlant &&
                    proPlantCapacityAdd
                  ? nutritionMemoizedMarkerRender // for lines
                  : null}
                {showDepots ? renderDepotPoints() : null}
                { renderFactoryPoints()} // for Processing plant (1st senario)
                {renderPackagingPoints()} // for Packaging plant (2nd senario)
              </AzureMapDataSourceProvider>

              <AzureMapPopup
                isVisible={popupOptions ? true : false}
                options={popupOptions}
                popupContent={
                  <>
                    <div style={{ padding: '8px' }}>
                      <span>
                        {popupProperties}
                        <br /> City: {popUpContent[1]}
                      </span>
                    </div>
                  </>
                }
                // <div style={{ padding: "8px 16px" }}>
                //   <h3>{popupOptions?.data && "Position: " + popupOptions?.data[0]?.positions}</h3>
                //   <h5>{popupOptions?.data && "City: " + popupOptions?.data[0]?.City}</h5>
                // </div> // Inject your JSX
              />
            </AzureMap>
          </div>
        </AzureMapsProvider>
      </>
    );
  };

  const handleProPlant = (e) => {
    setProPlant(e);
  };

  const handleProPlantCapacityAdd = (e) => {
    setProPlantCapacityAdd(e);
  };

  const handlePackPlant = (e) => {
    // setShow2(e.target.checked);
    setPackPlant(e);
  };

  const handlePackPlantAdd = (e) => {
    // setShow2(e.target.checked);
    setPackPlantAdd(e);
  };

  const renderLegendOptions = () => {
    let uc = localStorage.getItem('selectedUsecase');
    let sr = localStorage.getItem('selectedRadio');
    // let ucid = uc == "Short Term" ? 1 : 2;
    // let srid = sr == "masterData" ? 1 : 2;

    if (uc === 'Short Term' && sr === 'masterData') {
      return (
        <div className="legends-panel ">
          <ul>
            <li>
              <img src={marker3}></img>
            </li>
            <li>
              <span>Processing Factory</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>
          <ul>
            <li>
              <img src={locator}></img>
            </li>
            <li>
              <span>Depot</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>
          <ul>
            <li>
              <span className="barliine">____</span>
            </li>
            <li>
              <span>Out-bound to Depots</span>
            </li>
            <li></li>
          </ul>
        </div>
      );
    } else if (uc === 'Short Term' && sr === 'inputData') {
      return (
        <div className="legends-panel ">
          <ul>
            <li>
              <img src={marker3}></img>
            </li>
            <li>
              <span>Processing Factory</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>
          <ul>
            <li>
              <img src={locator}></img>
            </li>
            <li>
              <span>Depots</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>

          <ul>
            <li>
              <img src={marker3}></img>
            </li>
            <li>
              <span>Packaging</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>
          <ul>
            <li>
              <span className="barliine">____</span>
            </li>
            <li>
              <span>Out-bound to Depots</span>
            </li>
            <li></li>
          </ul>
          <ul>
            <li>
              <span className="barliine">____</span>
            </li>

            <li>
              <span>In-bound to packaging plant from Processing plant</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>
        </div>
      );
    } else if (uc === 'Medium Term' && sr === 'masterData') {
      return (
        <div className="legends-panel ">
          {proPlantShow && <ul>
            <li>
              <img src={processingPlant}></img>
            </li>
            <li>
              <span>Proccessing Plant</span>
            </li>
            <li></li>
            <li>
              <input
                checked={proPlant}
                onChange={(v) => handleProPlant(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>}
          {proPlantCapacityAddShow &&  <ul>
            <li>
              <img src={processingPlantCapacity}></img>
            </li>
            <li>
              <span>Proccessing Plant Capacity Add</span>
            </li>
            <li></li>
            <li>
              <input
                checked={proPlantCapacityAdd}
                onChange={(v) => handleProPlantCapacityAdd(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>}
         {depotShow &&  <ul>
            <li>
              <img src={locator}></img>
            </li>
            <li>
              <span>Depots</span>
            </li>
            <li></li>
            <li>
              <input
                checked={showDepots}
                onChange={(v) => setShowDepots(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>}
          <ul>
            <li>
              <span className="barliine">____</span>
            </li>
            <li>
              <span>Out-bound to Depot</span>
            </li>
            <li></li>
          </ul>
        </div>
      );
    } else {
      return (
        <div className="legends-panel ">
          {/* <ul>
            <li><span className="barliine">____</span></li>

            <li><span>In-bound to packaging plant from Processing plant</span></li>
            <li></li>
            <li><input type="checkbox" className="pull-right" /></li>
          </ul> */}
         {proPlantShowL &&  <ul>
            <li>
              <img src={processingPlant}></img>
            </li>
            <li>
              <span>Proccessing Plant</span>
            </li>
            <li></li>
            <li>
              <input
                checked={proPlant}
                onChange={(v) => handleProPlant(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>}
         {proPlantCapacityAddShowL && <ul>
            <li>
              <img src={processingPlantCapacity}></img>
            </li>
            <li>
              <span>Proccessing Plant Capacity Add</span>
            </li>
            <li></li>
            <li>
              <input
                checked={proPlantCapacityAdd}
                onChange={(v) => handleProPlantCapacityAdd(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>}
          {packPlantShow && <ul>
            <li>
              <img src={packagingPlant1}></img>
            </li>
            <li>
              <span>Packaging Plant</span>
            </li>
            <li></li>
            <li>
              <input
                checked={packPlant}
                onChange={(v) => handlePackPlant(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>}
          {packPlantAddShow  && <ul>
            <li>
              <img src={packagingPlantCapacity}></img>
            </li>
            <li>
              <span>Packaging Plant Add</span>
            </li>
            <li></li>
            <li>
              <input
                checked={packPlantAdd}
                onChange={(v) => handlePackPlantAdd(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>}
          {depotShowL && <ul>
            <li>
              <img src={locator}></img>
            </li>
            <li>
              <span>Depots</span>
            </li>
            <li></li>
            <li>
              <input
                checked={showDepots}
                onChange={(v) => setShowDepots(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>}
          
          <ul>
            <li>
              <span className="barliine">____</span>
            </li>
            <li>
              <span>In-bound to Depot from Packaging</span>
            </li>
            <li></li>
          </ul>
        </div>
      );
    }
  };

  const resetFilter = () => {
    if (!resultData?.azureMapsMTHCFilterModel) {
      return;
    }
    console.log(resultData?.azureMapsMTHCFilterModel, '------- resultdata.');

    setFilterTableData([...resultData?.azureMapsMTHCFilterModel]);

    let list = [...resultData?.azureMapsMTHCFilterModel];

    let fcList = [],
      fmList = [],
      bpList = [],
      dpList = [],
      cpTypeList = [];
    list.forEach((each) => {
      if (each.factory_Code) {
        if (!fcList.some((item) => item.key === each.factory_Code)) {
          fcList.push({ key: each.factory_Code, value: each.factory_Code });
        }
      }

      if (each.depot) {
        if (!dpList.some((item) => item.key === each.depot)) {
          dpList.push({ key: each.depot, value: each.depot });
        }
      }

      if (each.format) {
        if (!fmList.some((item) => item.key === each.format)) {
          fmList.push({ key: each.format, value: each.format });
        }
      }

      if (each.basepack_Code) {
        if (!bpList.some((item) => item.key === each.basepack_Code)) {
          bpList.push({ key: each.basepack_Code, value: each.basepack_Code });
        }
      }

      if (each.capacityType) {
        if (!cpTypeList.some((item) => item.key === each.capacityType)) {
          cpTypeList.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    setFactoryList([...fcList]);

    setDepotList([...dpList]);

    setFormatList([...fmList]);

    setBasepackList([...bpList]);

    setCpTypeList([...cpTypeList]);

    setSelectedFactory([]);
    setSelectedDepot([]);
    setSelectedFormat([]);
    setSelectedBasepack([]);
    setSelectedCpType([]);
  };

  const resetNFilter = () => {
    if (!nutritionResultData?.azureMapsMTNutritionFilterModel) {
      return;
    }

    setFilterTableData([
      ...nutritionResultData?.azureMapsMTNutritionFilterModel,
    ]);

    let list = [...nutritionResultData?.azureMapsMTNutritionFilterModel];

    let nProcessingL = [],
      nSFGL = [],
      nPackagingL = [],
      nBasepackL = [],
      nFormatL = [],
      nDepotL = [],
      nCpTypeL = [];
    list.forEach((each) => {
      if (each.processing) {
        if (!nProcessingL.some((item) => item.key === each.processing)) {
          nProcessingL.push({ key: each.processing, value: each.processing });
        }
      }

      if (each.sfg) {
        if (!nSFGL.some((item) => item.key === each.sfg)) {
          nSFGL.push({ key: each.sfg, value: each.sfg });
        }
      }

      if (each.packing) {
        if (!nPackagingL.some((item) => item.key === each.packing)) {
          nPackagingL.push({ key: each.packing, value: each.packing });
        }
      }

      if (each.basepack) {
        if (!nBasepackL.some((item) => item.key === each.basepack)) {
          nBasepackL.push({ key: each.basepack, value: each.basepack });
        }
      }

      if (each.format) {
        if (!nFormatL.some((item) => item.key === each.format)) {
          nFormatL.push({ key: each.format, value: each.format });
        }
      }

      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }

      if (each.capacityType) {
        if (!nCpTypeL.some((item) => item.key === each.capacityType)) {
          nCpTypeL.push({ key: each.capacityType, value: each.capacityType });
        }
      }
    });

    // setFactoryList([...fcList]);

    // setDepotList([...dpList]);

    // setFormatList([...fmList]);

    // setBasepackList([...bpList]);

    setNProcessingList([...nProcessingL]);
    setNSFGList([...nSFGL]);
    setNPackagingList([...nPackagingL]);
    setNBasepackList([...nBasepackL]);
    setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);
    setNCpTypeList([...nCpTypeL]);

    setSelectedNProcessing([]);
    setSelectedNSFG([]);
    setSelectedNPackaging([]);
    setSelectedNBasepack([]);
    setSelectedNFormat([]);
    setSelectedNDepot([]);
    setSelectedNCpType([]);
  };

  const mapPointClicked = (det, heading, imgUrl) => {
    if (selectedCategoryId === 1) {
      if (heading === 'Depot') {
        setSelectedDepot([
          {
            key: det.text,
            value: det.text,
          },
        ]);
      } else {
        setSelectedFactory([
          {
            key: det.text,
            value: det.text,
          },
        ]);
      }
    } else {
      if (heading === 'Depot') {
        setSelectedNDepot([
          {
            key: det.text,
            value: det.text,
          },
        ]);
      } else if (heading === 'Packaging Plant') {
        setSelectedNPackaging([
          {
            key: det.text,
            value: det.text,
          },
        ]);
      } else {
        setSelectedNProcessing([
          {
            key: det.text,
            value: det.text,
          },
        ]);
      }
    }
    // if (heading === "Processing Plant") {
    //   setSelectedFactory(det.text);
    // } else {
    //   setSelectedDepot(det.text);
    // }
    setshowLegendDetails(false);
    setshowMapFiltersDetails(true);
    setViewDetail(true);
    setCurrentDetail({ ...det, heading: heading, imgUrl: imgUrl });
    // setSelectedFactory(det.factory_Code);
    // setSelectedFactory("ABC")
  };

  return (
    <div className="App">
      {/* map-filter info */}
      <div
        className="map-filters"
        onClick={() => {
          setViewDetail(false);
          setshowMapFiltersDetails(true);
          setshowLegendDetails(false);
        }}
      >
        {/* <div className="map-filters" > */}
        <span className="direction-symbol">&#171; &nbsp;</span>
        <span>Map Filter</span>
      </div>

      {showMapFiltersDetails && (
        <div className="map-filter-panel">
          <div className="header">
            {/* <span className="pull-right"><a href="#" className="collapse-btn" onClick={() => setshowMapFiltersDetails(false)}>Collapse&nbsp; &#187;</a></span> */}
            {!viewDetail ? (
              <>
                <span className="pull-left">
                  <h2>Map Filter</h2>
                </span>
                <span className="pull-right">
                  <a
                    href="#"
                    className="collapse-btn"
                    onClick={() => {setshowMapFiltersDetails(false) 
                     selectedCategoryId === 1 ? resetFilter() : resetNFilter();}}
                  >
                    Collapse&nbsp; &#187;
                  </a>
                </span>
                <span
                  onClick={() => {
                    // setshowMapFiltersDetails(false);
                    // setViewDetail(false);
                    selectedCategoryId === 1 ? resetFilter() : resetNFilter();
                  }}
                >
                  <RestoreOutlinedIcon className="restoreIcon1" />
                </span>
              </>
            ) : null}
          </div>
          <div className="clear"></div>

          {!viewDetail ? (
            selectedCategoryId === 1 ? (
              <div className="filters">
                {/* <select onChange={(e) => {
                      if (e.target.value === "Factory") {
                        setSelectedFactory("");
                      } else {
                        setSelectedFactory(e.target.value);
                      }
                    }} value={selectedFactory}>
                      {
                        factoryList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedFactory}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={factoryList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedFactory(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Factory"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Depot") {
                        setSelectedDepot("");
                      } else {
                        setSelectedDepot(e.target.value);
                      }
                    }} value={selectedDepot}>
                      {
                        depotList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedDepot}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={depotList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedDepot(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Depot"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Format") {
                        setSelectedFormat("");
                      } else {
                        setSelectedFormat(e.target.value);
                      }
                    }} value={selectedFormat}>
                      {
                        formatList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedFormat}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={formatList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedFormat(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Format"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Basepack") {
                        setSelectedBasepack("");
                      } else {
                        setSelectedBasepack(e.target.value);
                      }
                    }} value={selectedBasepack}>
                      {
                        basepackList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedBasepack}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={basepackList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedBasepack(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Basepack"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Capacity Type") {
                        setSelectedCpType("");
                      } else {
                        setSelectedCpType(e.target.value);
                      }
                    }} value={selectedCpType}>
                      {
                        cpTypeList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedCpType}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={cpTypeList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedCpType(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Capacity Type"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              </div>
            ) : (
              <div className="filters">
                {/* <select onChange={(e) => {
                      if (e.target.value === "Processing") {
                        setSelectedNProcessing("");
                      } else {
                        setSelectedNProcessing(e.target.value);
                      }
                    }} value={selectedNProcessing}>
                      {
                        nProcessingList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNProcessing}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nProcessingList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNProcessing(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Factory"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "SFG") {
                        setSelectedNSFG("");
                      } else {
                        setSelectedNSFG(e.target.value);
                      }
                    }} value={selectedNSFG}>
                      {
                        nSFGList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNSFG}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nSFGList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNSFG(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="SFG"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Packaging") {
                        setSelectedNPackaging("");
                      } else {
                        setSelectedNPackaging(e.target.value);
                      }
                    }} value={selectedNPackaging}>
                      {
                        nPackagingList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNPackaging}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nPackagingList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNPackaging(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Packaging"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Basepack") {
                        setSelectedNBasepack("");
                      } else {
                        setSelectedNBasepack(e.target.value);
                      }
                    }} value={selectedNBasepack}>
                      {
                        nBasepackList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNBasepack}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nBasepackList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNBasepack(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Basepack"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Format") {
                        setSelectedNFormat("");
                      } else {
                        setSelectedNFormat(e.target.value);
                      }
                    }} value={selectedNFormat}>
                      {
                        nFormatList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNFormat}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nFormatList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNFormat(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Format"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Depot") {
                        setSelectedNDepot("");
                      } else {
                        setSelectedNDepot(e.target.value);
                      }
                    }} value={selectedNDepot}>
                      {
                        nDepotList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNDepot}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nDepotList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNDepot(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Depot"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Capacity Type") {
                        setSelectedNCpType("");
                      } else {
                        setSelectedNCpType(e.target.value);
                      }
                    }} value={selectedNCpType}>
                      {
                        nCpTypeList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNCpType}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nCpTypeList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNCpType(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Capacity Type"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              </div>
            )
          ) : (
            <div className="sidePanel-title">
              <div className="pull-left">
                <h2 className="sidepanel-header">{currentDetail.heading}</h2>
                <img
                  src={
                    currentDetail.imgUrl
                      ? currentDetail.imgUrl
                      : processingPlant
                  }
                  className="title-icon"
                ></img>
                <span className="text-indent">{currentDetail.text}</span>
                <span>|</span>
                <span>{currentDetail.title}</span>
                <span>|</span>
                <span>
                  {currentDetail.latitude}, {currentDetail.longitude}
                </span>
              </div>
              <div className="pull-right">
                <span
                  onClick={() => {
                    setshowMapFiltersDetails(false);
                    setViewDetail(false);

                    selectedCategoryId === 1 ? resetFilter() : resetNFilter();
                  }}
                >
                  <a className="collapse-btn1">
                    Exit <span className="small-font">&#10060;</span>
                  </a>
                </span>
              </div>
            </div>
          )}
          <br></br>
          <div className="filter-dataTable scrollbar">
            {selectedCategoryId === 1 ? (
              <table cellPadding={0} cellSpacing={0}>
                <tr>
                  <th>Factory</th>
                  <th>Depot</th>
                  <th>Basepack</th>
                  <th>CO2</th>
                  <th>Demand Location Code</th>
                  <th>Distance</th>
                  <th>Format</th>
                  <th>Time Period</th>
                </tr>

                {filterTableData.map((each, idx) => (
                  <tr key={idx}>
                    <td>{each.factory_Code}</td>
                    <td>{each.depot}</td>
                    <td>{each.basepack_Code}</td>
                    <td>{each.cO2}</td>
                    <td>{each.demand_Location_Code}</td>
                    <td>{each.distance}</td>
                    <td>{each.format}</td>
                    <td>{each.time_Period}</td>
                  </tr>
                ))}
              </table>
            ) : (
              <table cellPadding={0} cellSpacing={0}>
                <tr>
                  <th>Processing</th>
                  <th>SFG</th>
                  <th>Packaging</th>
                  <th>Format</th>
                  <th>Basepack</th>
                  <th>Depot</th>
                  <th>Volume</th>
                  <th>Capacity Type</th>
                  <th>CO2</th>
                </tr>

                {filterTableData.map((each, idx) => (
                  <tr key="idx">
                    <td>{each.processing}</td>
                    <td>{each.sfg}</td>
                    <td>{each.packing}</td>
                    <td>{each.format}</td>
                    <td>{each.basepack}</td>

                    <td>{each.depot}</td>
                    <td>{each.volume}</td>

                    <td>{each.capacityType}</td>
                    <td>{each.cO2}</td>
                  </tr>
                ))}
              </table>
            )}
          </div>
          <br></br>
          {/* <div className="filter-dataTable scrollbar">
            <table cellPadding={0} cellSpacing={0}>
              <tr>
                <th>Pro Plant</th>
                <th>Depot</th>
                <th>Flow</th>
                <th>RM/PM landed cost</th>
                <th>Processing cost + Packaging cost</th>
                <th>SFG trasportation cost</th>
                <th>Primary transportation cost</th>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
            </table>
          </div> */}
        </div>
      )}

      {/* --//-- */}
      {/* legends info */}
      <div className="map-legend" onClick={() => setshowLegendDetails(true)}>
        {/* <span><img src={locator} ></img></span> */}
        <span className="direction-symbol">&#171; &nbsp;</span>
        <span>Legend</span>
        {showLegendDetails && (
          <span
            href="#"
            onClick={(e) => {
              e.stopPropagation();
              setshowLegendDetails(false);
            }}
          >
            &nbsp;&#10060;
          </span>
        )}
      </div>

      {showLegendDetails && renderLegendOptions()}

      <div className="legends-panel hide" id="longTerm-scenario">
        <ul>
          <li>
            <img src={processingPlant}></img>
          </li>
          <li>
            <span>Processing Plant</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={processingPlantAdd}></img>
          </li>
          <li>
            <span>Processing Plant Add</span>
          </li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={processingPlantCapacity}></img>
          </li>
          <li>
            <span>Processing Plant Capacity Add</span>
          </li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={processingPlantRemove}></img>
          </li>
          <li>
            <span>Processing Plant Remove</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={packagingPlant1}></img>
          </li>
          <li>
            <span>Packaging Plant</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={packagingPlant2}></img>
          </li>
          <li>
            <span>Packaging Plant</span>
          </li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={packagingPlantCapacity}></img>
          </li>
          <li>
            <span>Packaging Plant Capacity Add</span>
          </li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={packagingPlantRemove}></img>
          </li>
          <li>
            <span>Packaging Plant Remove</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={locator}></img>
          </li>
          <li>
            <span>Depots</span>
          </li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={supplierMap}></img>
          </li>
          <li>
            <span>Supplier</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={inBoundLine}></img>
          </li>
          <li>
            <span>In-bound to packaging plant from Processing plant</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <span className="barliine">____</span>
          </li>
          <li>
            <span>In-bound to Depot from Packging</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={inBoundtoSupplier}></img>
          </li>
          <li>
            <span>In bound to Processing Pant from Supplier</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
      </div>

      <div className="legends-panel hide" id="mediumTerm-scenario">
        <ul>
          <li>
            <img src={marker3}></img>
          </li>
          <li>
            <span>Processing Plant</span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
        <ul>
          <li>
            <img src={processingPlantCapacity}></img>
          </li>
          <li>
            <span>Processing Plant Capacity Add</span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
        <ul>
          <li>
            <img src={packagingPlant1}></img>
          </li>
          <li>
            <span>Packaging Factory</span>
          </li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
          <li></li>
        </ul>
        <ul>
          <li>
            <img src={packagingPlantCapacity}></img>
          </li>
          <li>
            <span>Packaging plant to Capacity Add</span>
          </li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
          <li></li>
        </ul>
        <ul>
          <li>
            <img src={locator}></img>
          </li>
          <li>
            <span>Depots</span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
        <ul>
          <li>
            <img src={inBoundLine}></img>
          </li>
          <li>
            <span>In-bound to packaging plant from Processing plant</span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
        <ul>
          <li>
            <span className="barliine">____</span>
          </li>
          <li>
            <span>Inbound to Depot from Packaging </span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
      </div>
      <div className="over">
        <MarkersExample />
      </div>

      {/* { selectedCategoryId !== 1 ? <div className='overlap'>
           <span className='legendtotal'>
           <span className='legend'>
             <img alt="legendimage" src={marker1} className='legendimage'></img>
             <p className='para'>Depot</p>
           </span>
           <span className='legend'>
             <img alt="legendimage" src={marker3} className='legendimage'></img>
             <p className='para'>Factory</p>
           </span>
           <span className='legend'>
             <img alt="legendimage" src={products} className='legendimage'></img>
             <p className='para'>Packaging</p>
           </span>
           <span className='legend'>
             <img alt="legendimage" src={capacity} className='legendimage'></img>
             <p className='para'>Factory (Add)</p>
           </span>
           </span>
       </div> : <div className='overlap'>
             <span className='legendtotal'>
             <span className='legend'>
               <img alt="legendimage" src={marker1} className='legendimage'></img>
               <p className='para'>Depot</p>
             </span>
             <span className='legend'>
               <img alt="legendimage" src={marker3} className='legendimage'></img>
               <p className='para'>Factory</p>
             </span>
             <span className='legend'>
               <img alt="legendimage" src={capacity} className='legendimage'></img>
               <p className='para'>Factory (Add)</p>
             </span>
           
             </span>
       </div> } */}
    </div>
  );
}
